import axios from 'axios';
import store from '../../store/store';
import { forceFileDownload } from '../../utils/utils';

export const fetchCompletedDues = async (pagination) => {
    return await axios.get('/due', {
        params: {
            page: pagination.currentPage,
            pageLimit: pagination.itemsPerPage,
            enterpriseUuid: store.getters.enterpriseUuid,
            'status': ['created', 'ready_to_sign', 'signed', 'effective', 'non_effective']
        }
    });
};

export const fetchEffectiveDues = async () => {
    return await axios.get('/due', {
        params: {
            'status': ['effective'],
            enterpriseUuid: store.getters.enterpriseUuid
        }
    });
};

export const fetchDueById = async (dueId) => {
    return await axios.get(`/due/${ dueId }`);
};

export const updateDueById = async (dueId, formData) => {
    return await axios.put(`/due/${ dueId }`, formData);
}

export const createDue = async (formData) => {
    return await axios.post('/due', formData, {
        params: {
            enterpriseUuid: store.getters.enterpriseUuid
        }
    });
};

export const downloadDueWitSupportingDocuments = async (dueId, excludeSupportingDocuments = false) => {
    await forceFileDownload(
        `due/${ dueId }/download`,
        'Due.zip',
        'application/zip',
        {
            params: {
                'filter[excludeSupportingDocuments]': excludeSupportingDocuments
            }
        }
    );
};

export const downloadDueWitSupportingDocumentsByToken = async (dueAccessToken, excludeSupportingDocuments = false) => {
    await forceFileDownload(
        `/due/employee-emails/${dueAccessToken}/download`,
        'Due.zip',
        'application/zip',
        {
            params: {
                'filter[excludeSupportingDocuments]': excludeSupportingDocuments
            }
        }
    );
};

export const legalRepresentativeDownloadDueByAccessToken = async (accessToken) => {
    await forceFileDownload(
        `/legal-representative/due/${ accessToken }/download`,
        'Due.zip',
        'application/zip',
        { params: { 'filter[excludeSupportingDocuments]': false } }
    );
}

export const makeDueEffective = async (dueId) => {
    return await axios.post(`/due/${ dueId }/make-effective`);
};

export const fetchDueLegalRepresentativeByAccessToken = async (accessToken) => {
    return await axios.get(`/legal-representative/due/${ accessToken }`);
};

export const startDueSignByAccessToken = async (accessToken, phoneNumber, isPolicyAccepted) => {
    return await axios.post(`/legal-representative/due/${ accessToken }/start-sign`, {
        phoneNumber,
        isPolicyAccepted
    });
};

export const fetchEmployeeSharedPercentage = async (contributionOptionUnitId, collectiveAgreementId) => {
    return await axios.get('/contribution-employer-minimum-percentages', {
        params: {
            'filter[contributionOptionUnitId]': contributionOptionUnitId,
            'filter[collectiveAgreementId]': collectiveAgreementId
        }
    });
};

export const fetchCollectiveAgreementReasonsById = async (collectiveAgreementId) => {
    return await axios.get('/collective-agreement-reasons', {
        params: {
            'filter[collectiveAgreementId]': collectiveAgreementId
        }
    });
};

export const fetchDueLegalInformation = async () => {
    return await axios.get(`${ process.env.VUE_APP_CORE_HOST.replace('/v1', '/v2') }/due/legal-information`);
};

export const fetchDueLegalInformationByResetPasswordToken = async (accessToken) => {
    return await axios.get(`${ process.env.VUE_APP_CORE_HOST.replace('/v1', '/v2') }/due/legal-information/reset-token/${ accessToken }`);
};

export const fetchDueLegalInformationByDueAccessToken = async (accessToken) => {
    return await axios.get(`${ process.env.VUE_APP_CORE_HOST.replace('/v1', '/v2') }/due/legal-information/${ accessToken }`);
};

export const fetchCollectiveAgreementsByCodeNaf = async (codeNaf) => {
    return await axios.get('/collective-agreements', {
        params: {
            'filter[codeNaf]': codeNaf
        }
    })
};

export const fetchBeneficiariesByCollectiveAgreementId = async (collectiveAgreementId) => {
   return await axios.get('/beneficiaries', {
       params: {
           'collectiveAgreementId': collectiveAgreementId
       }
   });
};

export const fetchAllContributionOptionUnits = async () => {
    return await axios.get('/contribution-option-units');
};

export const fetchContributionOptionsByCollectiveAgreementId = async (collectiveAgreementId) => {
    return await axios.get('/contribution-options', {
        params: {
            'filter[collectiveAgreementId]': collectiveAgreementId
        }
    });
};

export const dueSendUpdateLink = async (dueId, data) => {
   return await axios.post(`/due/${ dueId }/mail/send-update-link`, data);
};

export const createContactLawyersResource = async (data) => {
    return await axios.post(
        '/due/contact-us-requests',
        data,
        {
            params: {
                enterpriseUuid: store.getters.enterpriseUuid
            }
        }
    );
};

export const saveEnterpriseOptionalReasons = async (formData) => {
    await axios.put('/private-settings', formData, {
        params: {
            enterpriseUuid: store.getters.enterpriseUuid
        }
    });
};

export const createAppContactUs = async (data) => {
    return await axios.post(
        '/contact-us-requests',
        data
    );
};

export const isBeneficiaryCoverage = async () => {
    return await axios.get('/beneficiaries/coverage', {
        params: {
            enterpriseUuid: store.getters.enterpriseUuid,
        }
    });
};

export const fetchEmployeeEmails = async (pagination, dueId) => {
    return await axios.get('/due/employee-emails', {
        params: {
            dueId,
            enterpriseUuid: store.getters.enterpriseUuid,
            page: pagination.currentPage,
            pageLimit: pagination.itemsPerPage,
            'status': [
                'created',
                'send_to_sendgrid',
                'delivered',
                'not_delivered',
                'bounce',
                'blocked',
                'deferred',
                'empty_response_data',
            ]
        }
    });
};

export const createDueSignOffSheetDocument = async (dueId, formData) => {
    return await axios.post(`/due/${ dueId }/sign-off-sheet-documents`, formData);
};

export const updateDueSignOffSheetDocument = async (dueId,  signOffSheetDocumentId, formData) => {
    return await axios.put(`/due/${ dueId }/sign-off-sheet-documents/${ signOffSheetDocumentId }`, formData);
};

export const deleteDueSignOffSheetDocument = async (dueId,  signOffSheetDocumentId) => {
    return await axios.delete(`/due/${ dueId }/sign-off-sheet-documents/${ signOffSheetDocumentId }`);
};

export const fetchDueSignOffSheetDocument = async (dueId) => {
    return await axios.get(`/due/${ dueId }/sign-off-sheet-documents`);
};

export const sendDueEmployeeEmails = async (formData) => {
    return await axios.post(`/due/employee-emails/send`, formData);
};

export const createAmendmentDue = async (formData) => {
    return await axios.post('/amendment-due', formData, {
        params: {
            enterpriseUuid: store.getters.enterpriseUuid
        }
    });
};

export const downloadAmendmentDueWitSupportingDocuments = async (amendmentDueId, excludeSupportingDocuments = false) => {
    await forceFileDownload(
        `amendment-due/${ amendmentDueId }/download`,
        'AvenantDUE.zip',
        'application/zip',
        {
            params: {
                'filter[excludeSupportingDocuments]': excludeSupportingDocuments,
                enterpriseUuid: store.getters.enterpriseUuid
            }
        }
    );
};
